import { useState, type ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { CrmSidebar } from "./CrmSidebar";
import { VoicePanel, VoicePanelToggle } from "@/components/voice/VoicePanel";

// Shell layout: left sidebar (nav), main content, right voice panel. The
// panel is a real layout column that grows from 0 to 400px instead of
// overlaying — content naturally reflows. The floating MessageCircle
// trigger only renders when the panel is closed; the panel's own close
// button handles the other direction.
//
// Most pages get a centered max-w-6xl wrapper so text content stays readable.
// Full-bleed pages (Calendar) opt out so their grid uses the full available width.
const FULL_BLEED_ROUTES = new Set<string>(["/calendar", "/meetings", "/tm-board", "/skills-board"]);

export const Layout = ({ children }: { children: ReactNode }) => {
  const [voicePanelOpen, setVoicePanelOpen] = useState(true);
  const { pathname } = useLocation();
  const fullBleed = FULL_BLEED_ROUTES.has(pathname);
  return (
    <div className="flex h-svh">
      <CrmSidebar />
      <main className="relative flex-1 overflow-auto bg-background">
        {!voicePanelOpen && (
          <div className="pointer-events-none absolute inset-x-0 top-0 z-30 flex justify-end px-6 py-4">
            <div className="pointer-events-auto">
              <VoicePanelToggle onClick={() => setVoicePanelOpen(true)} />
            </div>
          </div>
        )}
        {fullBleed ? (
          <div className="h-full">{children}</div>
        ) : (
          <div className="mx-auto max-w-6xl px-6 py-8">{children}</div>
        )}
      </main>
      <VoicePanel open={voicePanelOpen} onClose={() => setVoicePanelOpen(false)} />
    </div>
  );
};
